<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :entity-id="entityId"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";

export default {
  name: "CommentsWidget",
  components: { DynamicComponentProduction },
  mixins: [StoryPageElementMixin, DcHostMixin],
  relatedComponents: ["Comments Widget"],
  elementPanelSettings: {
    displayName: "Comments Widget",
    displayIcon: "document",
    elementGroup: "storyElements",
    elementType: "element",
  },
  options: [
    ReferencedComponentId,
    ContextBindings,
    new LayoutWidth({ "default": "fill" }),
  ],
  data() {
    return {
      defaultComponentName: "Comments Widget",
    };
  },
};
</script>
